import { useTheme } from '@mui/material/styles';

export const useStyles = (props = {}) => {
  const theme = useTheme();
  return {
    container: {
      color: theme.colorTokens.onSurfaceTextTitle,
    },
    dialogContent: {
      paddingLeft: theme.spacing(1.25),
      paddingRight: theme.spacing(1.25),
      paddingBottom: props.isMobile ? theme.spacing(12.5) : '0px',
    },
    text: {
      color: theme.colorTokens.onSurfaceTextTitle,
    },
  };
};
